export const WIDTH_BREAKPOINTS = {
  xs: "400px",
  sm: "600px",
  md: "900px",
  lg: "1200px",
  xl: "1400px",
};

export const APPRV = {
  APPROVAL: "승인",
  REVIEW: "검토",
};

export const APPRV_CD = {
  APPROVAL: "APTPA",
  PAYMENT: "APTPE",
  REVIEW: "APTPC",
  STEP: {
    APPROVAL: "APSPA",
    REJECT: "APSPD",
  },
};

export const THEME = {
  RED: "red",
  ORANGE: "orange",
  BLUE: "blue",
  GREEN: "green",
  DEFAULT: "light blue",
};

export const EXIST = "ifAuth";
export const CREATE_TAB_LIST = ["SYS110"]; // Program ID

export const PropConst = {
  authBtn: {
    ADD: "ADD",
    APPLY: "APPLY",
    APPR: "APPR",
    ATTACH: "ATTACH",
    BARCODEPRINT: "BARCODEPRINT",
    CANCEL: "CANCEL",
    CHANGE: "CHANGE",
    CLOSE: "CLOSE",
    COMPLETE: "COMPLETE",
    CONFIRM: "CONFIRM",
    COPY: "COPY",
    DELETE: "DELETE",
    DOWNLOAD: "DOWNLOAD",
    EXCEL: "EXCEL",
    HMODIFY: "HMODIFY",
    INIT: "INIT",
    MODIFY: "MODIFY",
    NONE: "NONE",
    OK: "OK",
    PRINT: "PRINT",
    RECOMMEND: "RECOMMEND",
    RECORDREV: "RECORDREV",
    REGISTE: "REGISTE",
    REJECT: "REJECT",
    RELOAD: "RELOAD",
    REMOVE: "REMOVE",
    RENTAL: "RENTAL",
    REQUEST: "REQUEST",
    RESET: "RESET",
    RETURN: "RETURN",
    REVISION: "REVISION",
    SAVE: "SAVE",
    SAVEALL: "SAVEALL",
    SEARCH: "SEARCH",
    SEARCHBOX: "SEARCHBOX",
    SETTING: "SETTING",
    UNSEARCHBOX: "UNSEARCHBOX",
    UPLOAD: "UPLOAD",
    WARINGSIGN: "WARINGSIGN",
  },
  buttonType: {
    default: "default",
    close: "close",
    search: "search",
  },
  iconType: {
    btn_add:"btn_add",
    btn_min: "btn_min",
    btn_copy: "btn_copy",
    btn_delete: "btn_delete",
    btn_trash: "btn_trash",
    btn_cancel: "btn_cancel",
    btn_close: "btn_close",
    btn_return: "btn_return",
    btn_ok: "btn_ok",
    btn_save: "btn_save",
    btn_floppy: "btn_floppy",
    btn_new: "btn_new",
    btn_file_up: "btn_file_up",
    btn_file_down: "btn_file_down",
    btn_cloud_up: "btn_cloud_up",
    btn_cloud_down: "btn_cloud_down",
    btn_excel: "btn_excel",
    btn_excel: "btn_clip",
    btn_link: "btn_link",
    btn_img: "btn_img",
    btn_popup: "btn_popup",
    btn_search:"btn_search",
    btn_print:"btn_print",
    btn_day:"btn_day",
    btn_list:"btn_list",
    btn_pen:"btn_pen",
    btn_order:"btn_order",
    btn_apply:"btn_apply",
    btn_warning:"btn_warning",
    btn_up:"btn_up",
    btn_down: "btn_down",
    btn_left: "btn_left",
    btn_right: "btn_right",
    btn_reset: "btn_reset",
    btn_add_w: "btn_add_w",
    btn_confirm_w: "btn_confirm_w",
  },
};
